<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-card width="500" class="mt-16" elevation="10">
            <v-toolbar flat color="primary" dark>
              <v-card-title class="font-weight-light"
                >Datos de acceso</v-card-title
              >
            </v-toolbar>
            <v-card-text>
              <v-form class="ma-4">
                <v-text-field
                  color="primary"
                  v-model="user"
                  type="email"
                  label="Correo electrónico"
                ></v-text-field>
                <v-text-field
                  color="primary"
                  v-model="password"
                  type="password"
                  label="Contraseña"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="login">Entrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable no-console*/
import { auth } from "../firebaseConfig.js";

export default {
  data() {
    return {
      user: null,
      password: null,
    };
  },
  created() {
    console.log(auth.currentUser);
  },
  methods: {
    login() {
      auth
        .signInWithEmailAndPassword(this.user, this.password)
        .then(() => {
          this.$router.replace("/home");
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
